export default __webpack_public_path__ + "static/media/icon-declined-fill.b367c725.svg";